import { useEffect, useState } from 'react';

// 本カスタムフックの返り値
export type UseCourseValue = {
  courseName: string; // コース名
};

const useCourse = (): UseCourseValue => {
  // コース名
  const [courseName, setCourseName] = useState<string>('');

  useEffect(() => {
    // サブディレクトリの取得
    const subDirectory = window.location.pathname.split('/');
    if (subDirectory === undefined) {
      return;
    }

    // サブディレクトリからコース名の判定
    if (subDirectory[1].includes('adv')) {
      setCourseName('Advanced');
    } else {
      setCourseName('Standard');
    }
  }, []);

  return {
    courseName,
  };
};
export default useCourse;
